import { render, staticRenderFns } from "./GroupCustomer.vue?vue&type=template&id=b4dad832"
import script from "./GroupCustomer.vue?vue&type=script&lang=js"
export * from "./GroupCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports